import React from "react";
import {Link} from "react-router-dom";
import {ArrowRight, CheckCircle2, ClipboardList, RotateCcw, BarChart3} from "lucide-react";
import {EXAM_PREP_PATH} from "../../constants/examPrep";
import "./ExamPrepDiscovery.css";
import {trackMockFunnel, useMockFunnelImpression} from "../../utils/mockFunnel";

export default function ExamPrepDiscovery() {
  const ref = useMockFunnelImpression("mock_discovery_view", {source:"homepage"});
  return <section ref={ref} className="exam-prep-discovery" aria-labelledby="exam-prep-discovery-title">
    <div className="exam-prep-discovery-copy">
      <span className="exam-prep-discovery-eyebrow">MEET YOUR EXAM PREP WORKSPACE</span>
      <h2 id="exam-prep-discovery-title">Your next step after<br/>typing practice.</h2>
      <p>Prepare for your government exam with mock tests, detailed results and focused practice for the questions you missed.</p>
      <ul>
        <li><ClipboardList size={18}/> Practise in a timed exam environment</li>
        <li><BarChart3 size={18}/> Review your score and solutions</li>
        <li><RotateCcw size={18}/> Reattempt wrong and skipped questions</li>
      </ul>
      <Link className="exam-prep-discovery-cta" to={EXAM_PREP_PATH} onClick={() => trackMockFunnel("mock_discovery_click", {source:"homepage"})}>Explore mock tests <ArrowRight size={18}/></Link>
      <small>Inside Aspirant Zone · Sign in to see available trials and tests.</small>
    </div>
    <div className="exam-prep-discovery-preview" aria-label="Mock practice journey preview">
      <div className="exam-prep-preview-heading"><ClipboardList size={18}/><strong>Mock Tests &amp; Exam Prep</strong><span>PREVIEW</span></div>
      <div className="exam-prep-preview-step"><span>01</span><div><strong>Choose your exam</strong><p>Find a mock for your preparation.</p></div></div>
      <div className="exam-prep-preview-step"><span>02</span><div><strong>Complete a timed mock</strong><p>Answer, review and submit your responses.</p></div></div>
      <div className="exam-prep-preview-complete"><CheckCircle2 size={24}/><div><strong>Test submitted!</strong><p>Your next step: review and improve.</p></div></div>
      <div className="exam-prep-preview-next"><span><BarChart3 size={15}/> Results &amp; analysis</span><span><RotateCcw size={15}/> Mistake practice</span></div>
    </div>
  </section>;
}
